import CardImageMedia, { CardImageMediaProps } from './CardImageMedia';

export default CardImageMedia;
export type { CardImageMediaProps };
